import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import {
  Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography, FormControlLabel, Checkbox, Box, Link, Modal, Grid, Toolbar, Snackbar,
} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditItemView from './EditItemView';
import EditAttributesView from './attributes/EditAttributesView';
import SelectField from './form/SelectField';
import deviceCategories from './common/deviceCategories';
import LinkField from './form/LinkField';
import { prefixString } from './common/stringUtils';
import { useTranslation } from './LocalizationProvider';
import useDeviceAttributes from './attributes/useDeviceAttributes';
import { Button } from '@material-ui/core';
import CreditLogsModal from './settings/CreditLogsModal';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import CarTypeTab from './components/CarTypeTab';
import { api_call, console_log, empty } from './helpers/untils';
import { Stack } from '@mui/material';
import TeslaQrCodeModal from './settings/TeslaQrCodeModal';
import CarTypeTabBar from './components/CarTypeTabBar';
import { DEVICE_TYPE, TESLA_SETUP_URL } from './config/constant';

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'column',
  },
}));

const TeslaDeviceListPage = () => {
  const classes = useStyles();
  const t = useTranslation();
  const { id } = useParams();

  const history = useHistory()
  const location = useLocation()

  const params = new URLSearchParams(location.search)
  const access_token = params.get("access_token")
  const refresh_token = params.get("refresh_token")
  console_log(`access_token,refresh_token:::::`, access_token, refresh_token)

  const user = useSelector((state) => state.session.user);
  const [item, setItem] = useState(
    {
      enableCycle: 0,
      accessToken: access_token,
      refreshToken: refresh_token,
    }
  );

  //////////////////////////////////////////////////////////////////////////////////////////////
  const [vehicleInfoList, setVehicleInfoList] = useState(null);

  useEffect(() => {
    getVehicleList();
  }, []);

  const getVehicleList = async () => {
    const response = await api_call(`/api/tesla/get-all-vehicles?access_token=${access_token}&refresh_token=${refresh_token}`);
    if (response.ok) {
      const res = await response.json()
      console_log("tesla vehicle list:::", res, item)
      const vehicle_info_list = res['vehicle_info_list']
      setVehicleInfoList(vehicle_info_list)
    } else {
      const errorRes = response
      console.log("Tesla errorRes:::", errorRes)
      alert(errorRes?.error ?? errorRes?.description ?? "Tesla Api error!")
      setVehicleInfoList([])
    }
  }

  const [checkedVehicleIdxs, setCheckedVehicleIdxs] = useState([])
  const OnChangeVehicleCheckBox = (index, event) => {
    const checked = event.target.checked
    let newCheckedIdxs = [...checkedVehicleIdxs];
    if (checked) {
      if (!checkedVehicleIdxs.includes(index)) {
        newCheckedIdxs = ([...checkedVehicleIdxs, index])
      }
    } else {
      if (checkedVehicleIdxs.includes(index)) {
        const newArr = checkedVehicleIdxs.filter(val => val !== index);
        newCheckedIdxs = ([...newArr])
      }
    }
    setCheckedVehicleIdxs(newCheckedIdxs)
    setItem({
      ...item,
      deviceType: DEVICE_TYPE.TESLA,
      vehicle_idxs: newCheckedIdxs,
      vehicle_info_list: vehicleInfoList,
      accessToken: access_token,
      refreshToken: refresh_token,
    })
    console_log("newCheckedIdxs:::", newCheckedIdxs)
  }
  const [openTeslaQrCodeModal, setOpenTeslaQrCodeModal] = useState(false);
  const callbackAfterSave = (v) => {
    history.push("/main")
    setTimeout(() => {
      window.open(TESLA_SETUP_URL, '_blank'); //setOpenTeslaQrCodeModal(true)
    }, 1000)
  }

  const onOkTeslaQrCodeModal = () => {
    history.push("/main")
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={() => { setSnackbarOpen(false) }}
        autoHideDuration={3000}
        message={toastMessage}
      />

      <EditItemView endpoint="devices" endpointParam1={DEVICE_TYPE.TESLA} item={item} setItem={setItem} callbackAfterSave={(v) => callbackAfterSave(v)}>
        {item
          && (
            <>
              <Accordion defaultExpanded>
                {
                  (item && item['id']) ? (<></>) : (
                    <CarTypeTabBar
                      currentPage="oem-device"
                    />
                  )
                }

                <AccordionDetails>
                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Typography variant="subtitle1">
                      Built In
                    </Typography>
                    {(item && item['id']) ? (
                      <Button variant="text" onClick={() => { }}>Balance:&nbsp;<span>{item.credit || '0.00'}</span></Button>
                    ) : (
                      <Button variant="text">Balance:&nbsp;<span>0.00</span></Button>
                    )}

                    <TextField
                      id="outlined-required"
                      label="Monthly ($)"
                      value={item.monthly_cost || '10.00'}
                      onChange={(event) => setItem({ ...item, monthly_cost: event.target.value })}
                      type="number"
                      inputProps={{ step: 0.01 }}
                      style={{ width: "100px" }}
                      disabled={!user.administrator && "true"}
                    />
                  </Box>
                </AccordionDetails>

                <AccordionDetails className={classes.details}>
                  <div className="vehicleListBox" style={{ marginBottom: '16px', paddingBottom: '16px', borderBottom: '1px solid rgba(0,0,0,0.12)' }}>
                    {
                      (vehicleInfoList === null) ? (
                        <div className='text-center'>Loading vehicles....</div>
                      ) : (
                        <>
                          <div>Vehicle list</div>
                          {(!empty(vehicleInfoList) && vehicleInfoList.length > 0) ? (
                            <>
                              <div>
                                {
                                  (vehicleInfoList.map((vehicleInfo, index) => {
                                    return (
                                      <div key={index}>
                                        <FormControlLabel
                                          control={<Checkbox checked={checkedVehicleIdxs.includes(index)} onChange={(event) => OnChangeVehicleCheckBox(index, event)} />}
                                          label={`${vehicleInfo['display_name']} ${vehicleInfo['vin']}`}
                                        />
                                      </div>
                                    )
                                  }))
                                }
                              </div>
                            </>
                          ) : (
                            <>
                              <div className='text-center'>No vehicle found</div>
                            </>
                          )}
                        </>
                      )
                    }
                  </div>

                  {id && <FormControlLabel
                    control={<Checkbox checked={item.disabled} onChange={(event) => setItem({ ...item, disabled: event.target.checked })} />}
                    label={t('sharedDisabled')}
                    disabled={id && !user.administrator && "true"}
                  />}
                </AccordionDetails>
              </Accordion>
            </>
          )}
      </EditItemView>

      <>
        <TeslaQrCodeModal
          open={openTeslaQrCodeModal}
          setOpen={setOpenTeslaQrCodeModal}
          onOk={() => onOkTeslaQrCodeModal()}
        />
      </>
    </>
  );
};

export default TeslaDeviceListPage;
